import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import FoodUpsellingForm from './FoodUpsellingForm'

const FoodUpsellingEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <FoodUpsellingForm toolbar={<WithDeleteModalToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default FoodUpsellingEdit
